import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import OTP from '../components/OTP_Component';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useHook as customerUpdateDevice } from '../../src/pages/auth/equipment/useHook';

interface PersonalDetailPopupProps {
  open: boolean;
  handleClose: () => void;
  handleSubmit: (data: any) => void;
  title: string;
  contentHeading: any;
  contentSubHeading?: string;
  btnText: string;
  imgURL: string;
  nameData?: any;
  timerCount?: boolean;
  handleResendOTP?: () => void;
}

const PersonalDetailPopup: React.FC<PersonalDetailPopupProps> = ({
  open,
  handleClose,
  handleSubmit,
  title,
  contentHeading,
  contentSubHeading,
  btnText,
  imgURL,
  nameData,
  timerCount,
  handleResendOTP,
}) => {
  const [otpValue, setOtpValue] = useState('');
  const [textFieldValue, setTextFieldValue] = useState('');
  const { id } = useParams();
  const { updateDeviceName } = customerUpdateDevice();
  const [initialValue, setInitialValue] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const nagivate = useNavigate();
  const location = useLocation();
  const urlPathName = location.pathname;
  const pathSegments = urlPathName.split('/');
  const ownedequipment = pathSegments.find(
    (segment) => segment === 'ownedequipment',
  );
  const [timer, setTimer] = useState(30); // Set initial timer value
  const [isTimerActive, setIsTimerActive] = useState(false);

  //otp resend
  const handleResendClick = () => {
    handleClosePopup();
    if (handleResendOTP) {
      handleResendOTP();
    }
  };

  useEffect(() => {
    if (nameData) {
      setTextFieldValue(nameData);
      setInitialValue(nameData);
    }
  }, [nameData]);

  const isButtonDisabled =
    btnText.toLowerCase().trim() === 'verify & proceed'
      ? textFieldValue.length < 6
      : textFieldValue === initialValue;

  const handlePopupSubmit = () => {
    const payload = {
      unitID: id,
      deviceName: textFieldValue,
    };
    updateDeviceName(payload)
      .then((res) => {
        handleSubmit('');
        handleClose();
        if (res) {
          if (ownedequipment == 'ownedequipment') {
            nagivate(
              `/equipment/ownedequipment/details/${textFieldValue?.replace(/ /g, '_')}/${id}`,
            );
          } else {
            nagivate(
              `/equipment/sharedwithmeequipment/details/${textFieldValue?.replace(/ /g, '_')}/${id}`,
            );
          }
        }
      })
      .catch((error) => {
        console.error('Error updating device name:', error);
      });
  };

  //validation
  const vaidation = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (
      title == 'Mobile Number' &&
      !phoneRegex.test(textFieldValue) &&
      btnText.toLowerCase().trim() !== 'verify & proceed'
    ) {
      setErrorMessage('Invalid Mobile Number');
      return false;
    }
    if (title == 'Email' && !emailRegex.test(textFieldValue)) {
      setErrorMessage('Invalid Email');
      return false;
    }
    return true;
  };

  //handle submit
  const handleUpdateSubmit = () => {
    if (vaidation()) {
      if (title == 'Name') {
        handlePopupSubmit();
      } else {
        handleSubmit(textFieldValue);
      }
      handleClosePopup();
    }
  };

  //handle closepopup
  const handleClosePopup = () => {
    setTextFieldValue(nameData || '');
    setErrorMessage('');
    handleClose();
    setIsTimerActive(false);
    setTimer(30);
  };

  const handleChangeValue = (value: any) => {
    setErrorMessage('');

    if (title === 'Mobile Number') {
      const sanitizedValue =
        typeof value === 'string' ? value.replace(/\D/g, '') : '';
      if (sanitizedValue.length <= 10) {
        setTextFieldValue(sanitizedValue);
      }
    } else {
      setTextFieldValue(value);
    }
  };

  //otp timer
  const startTimer = () => {
    setIsTimerActive(true);
    setTimer(30); // Reset timer to 30 seconds
    setIsTimerActive(true);
  };

  useEffect(() => {
    let interval: any;

    if (isTimerActive) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    if (timer === 0) {
      setIsTimerActive(false);
    }

    return () => {
      clearInterval(interval);
    };
  }, [timer, isTimerActive]);

  useEffect(() => {
    if (timerCount) {
      startTimer();
    }
  }, [timerCount]);

  return (
    <>
      <Dialog
        className="renew-popup"
        open={open}
        onClose={handleClosePopup}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title" className="renew_dialog-heading">
          {`Update ${title}`}
        </DialogTitle>
        <DialogContent className="renew_dialog-content">
          <div className="personaldetails_dialog-content-text">
            <div>
              <img src={imgURL} alt={`Update_Mail icon`} width="60" />
            </div>
            <div>
              <h4>{contentHeading}</h4>
              {contentSubHeading && <h5>{contentSubHeading}</h5>}
            </div>
          </div>

          {btnText.toLowerCase().trim() === 'verify & proceed' ? (
            <div className="personaldetails_dialog-content_otp-input">
              <OTP
                value={textFieldValue}
                onChange={setTextFieldValue}
                length={6}
              />
              <h5 className="resend_otp_count">
                Didn’t receive code?
                {isTimerActive ? (
                  <span> Resend OTP in {timer}s</span>
                ) : (
                  <span>
                    <Button onClick={handleResendClick}> Resend OTP</Button>
                  </span>
                )}
              </h5>
            </div>
          ) : (
            <div className="personaldetails_dialog_input">
              <TextField
                fullWidth
                placeholder={`Enter new ${title}`}
                value={textFieldValue}
                onChange={(e) => handleChangeValue(e.target.value)}
                error={errorMessage.length > 0}
                helperText={errorMessage}
              />
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <div className="renew_dialog-actions">
            <Button
              onClick={handleClosePopup}
              color="primary"
              variant="contained"
              className="renew-cancel-btn"
            >
              Cancel
            </Button>
            <Button
              onClick={handleUpdateSubmit}
              color="primary"
              variant="contained"
              className="renew-active-btn"
              // disabled={isDeleteButtonDisabled}
              disabled={isButtonDisabled || !textFieldValue}
            >
              {btnText}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PersonalDetailPopup;
